import { createContext } from 'react';
export var EmojiContext = /*#__PURE__*/createContext(null);